// ----------------------------------------------------------------------

const ROOTS = {
  AUTH: '/auth',
  DASHBOARD: '/dashboard',
};

// ----------------------------------------------------------------------

export const paths = {
  // AUTH
  auth: {
    firebase: {
      signIn: `${ROOTS.AUTH}/firebase/sign-in`,
      verify: `${ROOTS.AUTH}/firebase/verify`,
      signUp: `${ROOTS.AUTH}/firebase/sign-up`,
      resetPassword: `${ROOTS.AUTH}/firebase/reset-password`,
    },
  },
  // DASHBOARD
  dashboard: {
    root: ROOTS.DASHBOARD,
    district: {
      root: `${ROOTS.DASHBOARD}/district`,
      school: (schoolId: string) => `${ROOTS.DASHBOARD}/district/schools/${schoolId}`,
    },
    /** Department / Team Lead page (epic #566). */
    department: `${ROOTS.DASHBOARD}/department`,
    classOverview: `${ROOTS.DASHBOARD}/class-overview`,
    sessions: `${ROOTS.DASHBOARD}/sessions`,
    calendar: `${ROOTS.DASHBOARD}/calendar`,
    class: `${ROOTS.DASHBOARD}/class`,
    /**
     * A student's page (epic #595): Profile / Guardians / Sessions (/ Demographics) tabs.
     * `classId` scopes the class (deep links from any class); `tab` picks the tab.
     */
    student: (uid: string, opts: { classId?: string; tab?: 'profile' | 'guardians' | 'sessions' | 'demographics'; thread?: string; lesson?: string; alert?: string } = {}) => {
      const q = new URLSearchParams();
      if (opts.classId) q.set('classId', opts.classId);
      if (opts.tab && opts.tab !== 'profile') q.set('tab', opts.tab);
      if (opts.lesson) q.set('lesson', opts.lesson);
      if (opts.thread) q.set('thread', opts.thread);
      if (opts.alert) q.set('alert', opts.alert);
      const qs = q.toString();
      return `${ROOTS.DASHBOARD}/class/students/${uid}${qs ? `?${qs}` : ''}`;
    },
    /** A student's past tutoring sessions (epic #379) — the Sessions tab of the student page. `thread` selects one; `lesson` filters. */
    studentSessions: (uid: string, opts: { classId?: string; thread?: string; lesson?: string; alert?: string } = {}) =>
      paths.dashboard.student(uid, { ...opts, tab: 'sessions' }),
    curriculum: `${ROOTS.DASHBOARD}/curriculum`,
    standards: `${ROOTS.DASHBOARD}/standards`,
    reviews: `${ROOTS.DASHBOARD}/reviews`,
    lessonPlans: {
      root: `${ROOTS.DASHBOARD}/lesson-plans`,
      unit: (unitId: string) => `${ROOTS.DASHBOARD}/lesson-plans/${unitId}`,
      lesson: (unitId: string, lessonId: string) =>
        `${ROOTS.DASHBOARD}/lesson-plans/${unitId}/${lessonId}`,
    },
  },
};
